import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "onboarding-review__card" }
const _hoisted_2 = { class: "onboarding-review__stars" }
const _hoisted_3 = { class: "onboarding-review__text" }
const _hoisted_4 = { class: "onboarding-review__author" }

import { computed } from 'vue'

import { QuestionnaireView } from '@/models/onboarding'
import { ReviewPage } from '@/models/onboarding.types'

import Layout from '../Layout.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Review',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as ReviewPage
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: "onboarding-review",
    title: page.value.title,
    subtitle: page.value.subtitle
  }, {
    aboveTitle: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
            return _createElementVNode("span", {
              key: `star-${i}`,
              class: "onboarding-review__star iconfont istar"
            })
          }), 64))
        ]),
        _createElementVNode("p", _hoisted_3, _toDisplayString(page.value.review), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(page.value.reviewer), 1)
      ])
    ]),
    _: 1
  }, 8, ["title", "subtitle"]))
}
}

})